/**
 * Тестовый стенд: контент запрашивается с флагом draft — бэкенд подменяет
 * data на черновик dataDraft и отдаёт ещё не опубликованные записи.
 * На проде IS_DRAFT_SITE не задан, поэтому в ответ идут только опубликованные.
 */
export function isDraftSite(config) {
  return Boolean(config?.IS_DRAFT_SITE);
}

/** Хвост query-строки: параметр входит в путь, поэтому у стенда свои ключи кэша */
export function draftQueryParam(config) {
  return isDraftSite(config) ? "&draft=1" : "";
}
